<template >
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row justify="start" class="my-4 ml-1">
        <span class="display-1 titulo font-weight-bold">Mensagens</span>
      </v-row>
      <v-row>
        <v-expansion-panels flat popout>
          <v-expansion-panel outlined class="borda mb-1" v-for="(item,i) in mensagens" :key="i">
            <!-- <v-divider v-if="i != 0"></v-divider> -->
            <v-expansion-panel-header class="title">
              {{item.mensagem_titulo}}
              <span
                style="font-weight:normal; font-size: 15px"
                class="ml-1"
              >- {{item.created_at | moment('L')}}</span>
              <v-row>
                <v-spacer></v-spacer>
                <v-menu v-if="item.mensagem_lida == 1">
                  <template v-slot:activator="{ on }">
                    <v-btn @click="msgLida(item)" class="mr-4" icon v-on="on" text>
                      <v-icon>mdi-email-open-outline</v-icon>
                    </v-btn>
                  </template>
                </v-menu>
                <v-menu v-if="item.mensagem_lida == 0">
                  <template v-slot:activator="{ on }">
                    <v-btn @click="msgLida(item)" class="mr-4" icon v-on="on" text>
                      <v-icon>mdi-email-outline</v-icon>
                    </v-btn>
                  </template>
                </v-menu>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-divider class="mb-3"></v-divider>
              <span v-html="item.mensagem_descricao"></span>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-card v-if="mensagens.length == 0" class="borda" flat width="100%" height="75">
          <v-row justify="center" class="mt-5">
            <v-subheader>Nenhuma Mensagem recebida.</v-subheader>
          </v-row>
        </v-card>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
export default {
  data: () => {
    return {
      editModulo: false,
      mensagens: []
    };
  },
  created() {
    this.validaEdicaoModulo();
    this.getMessages();
  },

  methods: {
    msgLida(item) {
      let a = item;
      Api.post("/meu_titulo/mensagens/" + item.id_mensagem, a)
        .then(response => {
          if (response) {
            // this.getMessages();
            this.mensagens[this.mensagens.indexOf(item)].mensagem_lida =
              this.mensagens[this.mensagens.indexOf(item)].mensagem_lida == 1
                ? 0
                : 1;
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },
    getMessages() {
      let clube = JSON.parse(localStorage.getItem("clube-atual")).id_clube;
      let usuario = localStorage.getItem("user-token");
      Api.get(`/meu_titulo/mensagens?user_token=` + usuario + "&fk_id_clube=" + clube)
        .then(response => {
          if (response.data.data) {
            this.mensagens = response.data.data;
          }
        })
        .catch(err => {
          throw err;
        });
    },
    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo("/meu_titulo");
    }
  }
};
</script>
<style lang="scss">
input:disabled {
  cursor: default;
  border-color: #bdbdbd;
  color: #bdbdbd;
}
</style>